let jifenChangeBasicType = {
  0: '支付订单',
  1: '提现订单',
  2: '冲正',
  3: '充值与回收',
  4: '佣金转积分',
  5: '积分清零',
  15: '积分转佣金',
}
let jifenChangePlusType = {
  16: '【耗损】玩家修改金额、重复、延迟支付错误回调无法追回',
  17: '【耗损】兑换成功但账单延迟无法追回',
  18: '【耗损】操作员打款错误，误报订单信息造成无法追回',
  19: '【非耗损】特殊代理需我们上分跑量',
  20: '【非回血】特殊代理需回收上分',
  21: '【非回血】代理线下提领积分/佣金',
  996: '【非耗损】特殊操作 - 充值',
  997: '【非回血】特殊操作 - 回收',
  998: '【耗损】特别操作 - 充值',
  999: '【回血】特别操作 - 回收'
}

export default {
  // 佣金账变明细事件类型
  commissionChangeType: {
    0: '支付订单',
    1: '提现订单',
    4: '佣金转积分',
    6: '佣金提现',
    14: '佣金回退'
  },

  // ======= 积分帐变明细事件类型 start =======
  // 基本帐变类型
  jifenChangeBasicType,
  // 特别允许角色追加帐变类型
  jifenChangePlusType,
  // ======= 积分帐变明细事件类型 end =======

  // 商户帐变明细事件类型
  sellerChangeType: {
    0: '支付订单',
    1: '提现订单',
    2: '冲正',
    3: '充值与回收',
  },

  orderStatus: {
    changeType: {
      ...jifenChangeBasicType,
      6: '佣金提现',
      7: '财务提现（为客服充值）',
      14: '佣金回退',
      ...jifenChangePlusType
    },
    pay: {
      0: '订单成立',
      1: '处理中',
      2: '已完成',
      100: '收款失败',
      200: '已退款',
    },
    withdraw: {
      0: '订单成立',
      1: '处理中',
      2: '确认中',
      3: '已完成',
      4: '提交失败',
      5: '转帐失败',
      100: '付款失败',
      200: '已退款',
      300: '等待操作员确认',
      301: '操作员已确认',
      400: '冲正处理中',
    }
  },
  bankGroupDefaultOptions: {
    0: '一般',
    1: '预设 - 自动',
    2: '预设 - 手动',
  },
  refundStatus: {
    0: '未发起',
    1: '申请退款',
    2: '退款中',
    3: '退款完成',
    4: '退款失败',
    5: '拒绝退款',
    99: '申请直接退款',
    100: '直接退款成功',
  },
  faceVideoStatusOptions: {
    0: '尚未上传',
    1: '新上传',
    2: '初审通过',
    3: '实际可用',
    4: '不可用',
  },
  pagination: {
    pageSizes: [10, 20, 30, 50],
    pageSize: 20,
    pageSizeNoLimit: 99999,
  },
  message: {
    removeConfirm: '确定要移除吗？ ',
    confirm: '确定',
    cancel: '取消',
    warning: '警告',
    attention: '注意',
  },
  // 短信类型下拉
  smsTypeOption: [
    {
      label: "支付",
      value: "1",
      smsType: "payTemplateList",
    },
    {
      label: "提现",
      value: "2",
      smsType: "withdrawTemplateList",
    },
    {
      label: "转帐验证码",
      value: "3",
      smsType: "verifyCodeTemplateList",
    },
    {
      label: "登录验证码",
      value: "4",
      smsType: "bindVerifyCodeTemplateList",
    },
    {
      label: "冲正",
      value: "5",
      smsType: "refundTemplateList",
    },
    {
      label: "忽略",
      value: "6",
      smsType: "ignoreTemplateList",
    },
    {
      label: "额外报警",
      value: "7",
      smsType: "extraAlarmTemplateList",
    },
  ],
  smsTypeOptionExtra: {
    0: "未知",
    1: "支付",
    2: "提现",
    3: "转帐验证码",
    4: "登录验证码",
    5: "冲正",
    6: "忽略",
    7: "额外报警",
    8: "关键字误判",
  },
  smsType: {
    type: {
      1: "到帐",
      2: "转帐验证码",
      3: "登录验证码",
      4: "冲正"
    },
    orderType: {
      0: '支付订单',
      1: '提现订单'
    },
    failedType: {
      0: '模版解析失败',
      1: '日期解析失败',
      2: '关键字不匹配'
    }
  },
  // 帐户管理帐户类型
  accTypeOptions: [
    {
      label: "支付",
      value: 0,
    },
    {
      label: "提现",
      value: 1,
    },
    {
      label: "支付与提现",
      value: 2,
    },
    {
      label: "商户提现",
      value: 3,
    },
    {
      label: "商户归集",
      value: 4
    },
    {
      label: "出款归集",
      value: 5
    },
  ],
  // 帐户管理协议类型
  cryptoProtocolOptions: [
    {
      label: "波场链协议",
      value: 'TRC-20',
    },
    {
      label: "以太坊协议",
      value: 'ERC-20',
    },
    // {
    //   label: "比特币协议",
    //   value: 'OMNI',
    // },
  ],
  // 系统设置
  isSystemOptions: [
    {
      label: "系统类",
      value: true,
    },
    {
      label: "业务类",
      value: false,
    },
  ],
  // 订单异动状态
  changeStatusOptions: [
    {
      label: "正常",
      value: 0,
    },
    {
      label: "加速",
      value: 1,
    },
    {
      label: "取消",
      value: 2,
    },
  ],
  // 转账记录状态
  transferRecordStatusOptions: [
    {
      label: "正常",
      value: 0,
    },
    {
      label: "失败",
      value: 1,
    },
    {
      label: "待确认",
      value: -1,
    },
  ],
  // 转账记录类型
  transactionTypeOptions: [
    {
      label: "提现转账",
      value: 0,
    },
    {
      label: "加速",
      value: 1,
    },
    {
      label: "取消",
      value: 2,
    },
    {
      label: "归集",
      value: 3,
    },
    {
      label: "提现订单 - 补充矿工费",
      value: 4,
    },
    {
      label: '内部转帐',
      value: 5,
    },
    {
      label: '自动归集 - 加速',
      value: 6,
    },
    {
      label: '二级通道 - 手续费',
      value: 7,
    },
    {
      label: '二级通道 - 财务',
      value: 8,
    },
    {
      label: '一级通道 - 归集',
      value: 9,
    },
  ],
}


// WEBPACK FOOTER //
// ./src/utils/varCommon.js